import { AppRoutePaths } from '@/routing/route_paths'
import useStudenDetailsDocumentParams from '../hooks/useStudentDetailsDocumentParams'
import { useTranslation } from 'react-i18next'
import { CaptureInstructions } from './CaptureInstructions'
import { useTypesafeStudent } from '../useTypesafeStudent'

export const RelationshipCaptureInstructions = () => {
  const { t: translate } = useTranslation()
  const { fullName } = useTypesafeStudent()
  const { info, onRouteChange } = useStudenDetailsDocumentParams()
  const { student_details } = AppRoutePaths.family_application

  const selectedForm = info()

  function handleContinueClick() {
    onRouteChange(student_details.relationship.capture)
  }

  function handleCantFindClick() {
    onRouteChange(student_details.additional_details)
  }

  return (
    <>
      <div className="text-3xl text-center font-medium text-gray-900 mb-10 sm:mb-5">
        <h1>{translate('student_identity_verification')}</h1>
      </div>

      <div className="text-center text-xl text-gray-900 my-10 mb-3 sm:mb-2">
        {translate('we_need_student_relationship_document').replace(':student_name', fullName)}.
      </div>

      <div className="flex justify-center">
        <img src={selectedForm.image} className=" h-60 shadow-md" />
      </div>

      <CaptureInstructions 
        name={selectedForm.name}
        onCantFindClick={handleCantFindClick}
        onContinueClick={handleContinueClick}
      />
    </>
  )
}
